import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ICalculation } from "../../../../../models/calculation";
import { FileDropzone } from "../../../../Dropzone/FileDropzone";
import { dispatchLoadedCalculation } from "../../../../../containers/StudyPage/SaveLoadCalcButtons";
import { toast } from "../../../../..";
import { AppState } from "../../../../../store/configureStore";
import "./Upload.css";

export const Upload = () => {
    const dispatch = useDispatch();
    const availableTimestampsOrScenarios = useSelector((state: AppState) => state.validationProcess.availableTimestampsOrScenarios);

    const handleSetFile = useCallback(
        async (file: File) => {
            try {
                let fullText = await file.text();

                let calc: ICalculation = JSON.parse(fullText);
                await dispatchLoadedCalculation(dispatch, calc, availableTimestampsOrScenarios);
                toast("Loaded calculation parameters", true);
            } catch (err) {
                toast("Unable to load calculation parameters", false, 3000);
            }
        },
        [dispatch, availableTimestampsOrScenarios]
    );

    return (
        <div id="div-upload-a" className="transition-container">
            <FileDropzone essential="fileDropzone-upload-a" msg="Please upload a file" handleSetFile={handleSetFile} accept={{}} />
        </div>
    );
};
